module.exports = __webpack_public_path__ + "static/media/Asko_location.22112cf5.png";